module.exports = "/assets/src/client/assets/topLevelPage/styled-List.svg";